"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformItemsToSchedules = transformItemsToSchedules;
var _get4 = _interopRequireDefault(require("lodash/get"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
function transformItemsToSchedules(locationServices) {
  var groupedBySchedule = (0, _groupBy2["default"])(locationServices, function (item) {
    return (0, _get4["default"])(item, 'category.schedule._id');
  });
  return (0, _map2["default"])(groupedBySchedule, function (scheduleItems) {
    var _get2 = (0, _get4["default"])(scheduleItems, '0.category.schedule'),
      scheduleId = _get2._id,
      scheduleName = _get2.name;

    // Group items by category ID within each schedule
    var groupedByCategory = (0, _groupBy2["default"])(scheduleItems, function (item) {
      return (0, _get4["default"])(item, 'category._id');
    });
    var categories = (0, _map2["default"])(groupedByCategory, function (categoryItems) {
      var _get3 = (0, _get4["default"])(categoryItems, '0.category'),
        categoryId = _get3._id,
        categoryName = _get3.name;
      var finalCategoryItems = categoryItems.map(function (item) {
        return (0, _pick2["default"])(item, ['_id', 'name', 'variations']);
      });
      return {
        _id: categoryId,
        name: categoryName,
        items: finalCategoryItems
      };
    });
    return {
      _id: scheduleId,
      name: scheduleName,
      categories: categories
    };
  });
}